import CrudRepository from './CrudRepository'
export default class DeleteNumberRepository extends CrudRepository {
  constructor () {
    super('core/api/users/numbers')
  }
}
